import React, { useState, useEffect } from "react";
import ProductCard from "../../components/ProductComponents/ProductComponents";
import Footer from "../../components/footer/Footer";
import Nav from "../../components/nav/nav";
// import products from "./productsData";
import Whatsapp from '../../components/whatsapp/Whatsapp';
import ChargerIntro from "./productpage_components/ChargerIntro"
import ChargerDetails from "./productpage_components/ChargerDetails";
import { acCharger, dcCharger } from "./productpage_components/chargersData";

import "./product.css"; // Create this CSS file
import ProductHero from "./producthero";
function Product() {

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [ChargerData, setChargerData] = useState(null);
  const backendurl = "https://host.aizoplug.com:3000";
  const backendurl2 = "https://api.aizoteq.com:3000";
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await fetch(`${backendurl}/ecommerce/products?type=charger&online_sale=false`);
        const data = await res.json();

        if (data.success) {
          setProducts(data.data);

          //Transform API → ChargerData structure
          const formatted = data.data.map((item) => {
            const specs = item.details?.specifications || {};

            return {
              intro: {
                title: item.details?.title || item.model,
                description: item.details?.description || "",
                image: item.images?.[0]
                  ? `${backendurl2}${item.images[0]}`
                  : "",
              },

              details: {
                title: item.details?.title,
                model: item.model,
                image: item.images?.[0]
                  ? `${backendurl2}${item.images[0]}`
                  : "",

                accordionSections: [
                  {
                    id: "overview",
                    title: "Overview",
                    content: item.details?.short_description || "",
                  },
                  {
                    id: "specifications",
                    title: "Specifications",

                    //convert object → array
                    content: Object.entries(specs).map(([key, value]) => ({
                      label: key,
                      value: value,
                    })),
                  },
                ],

                features: item.details?.features || [],
                locations: [],
              },
            };
          });

          setChargerData(formatted);
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);
  // FETCH API
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await fetch(
          `${backendurl}/ecommerce/products?type=charger`
        );
        const data = await res.json();

        if (data.success) {
          setProducts(data.data);
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  return (
    <div className="product-page">
      <Nav />
      <Whatsapp />
      <ProductHero />
      <div className="products-container">
        <div className="products-grid">

          {/* ✅ LOADING */}
          {loading ? (
            <p>Loading products...</p>
          ) : products.length === 0 ? (
            <p>No products found</p>
          ) : (
            products.map((product) => (
              <ProductCard
                key={product.product_id}
                product={{
                  id: product.product_id,
                  name: product.details?.title,
                  price: product.details?.price || product.mrp,
                  image:
                    product.images?.[0]
                      ? `https://api.aizoteq.com:3000` + product.images[0]
                      : `https://api.aizoteq.com:3000` + product.details?.image_url,
                  description: product.details?.short_description,
                }}
              />
            ))
          )}

        </div>
      </div>

      {ChargerData &&
        ChargerData.map((charger, index) => (
          <ChargerDetails
            key={`details-${index}`}
            {...charger.details}
            onDownload={() => console.log("Download clicked")}
            onEnquire={() =>
              window.open(
                "https://wa.me/918012523333?text=Hi%20I'm%20interested%20in%20your%20EV%20charger",
                "_blank"
              )
            }
          />
        ))}

      <ChargerIntro
        {...acCharger.intro}
        onReadMore={() => console.log("Read more clicked")}
        onEnquire={() => console.log("Enquire clicked")}
      />

      <ChargerIntro
        {...dcCharger.intro}
        onReadMore={() => console.log("Read more clicked")}
        onEnquire={() => console.log("Enquire clicked")}
      />


      <Footer />
    </div>
  );
}

export default Product;